import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffect, justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import {
  AppState,
  Dock,
  FulfillmentCenter,
  FulfillmentCentersStatus,
  FulfillmentCenterTypeFilters,
} from './types'

const initialState: AppState = {
  isLoading: false,
  fulfillmentCenters: [],
  fulfillmentCentersStatus: 'idle',
}

const isLoading = (state: AppState, action: PayloadAction<boolean>) => ({
  ...state, isLoading: action.payload,
})

const setUserBadge = (state: AppState, action: PayloadAction<boolean>) => ({
  ...state, userBadge: action.payload,
})

const setUserBarcode = (state: AppState, action: PayloadAction<string>) => ({
  ...state, userBarcode: action.payload,
})

const setToken = (state: AppState, action: PayloadAction<string | undefined>) => ({
  ...state, token: action.payload,
})

const setFulfillmentCenters = (state: AppState, action: PayloadAction<FulfillmentCenter[]>) => {
  state.fulfillmentCenters = action.payload
  state.fulfillmentCentersStatus = 'succeeded'
}

const setFulfillmentCentersFilters = (state: AppState, action: PayloadAction<FulfillmentCenterTypeFilters>) => {
  state.fulfillmentCentersFilters = action.payload
}

const setFulfillmentCentersStatus = (state: AppState, action: PayloadAction<FulfillmentCentersStatus>) => {
  state.fulfillmentCentersStatus = action.payload
}

const clearFulfillmentCenters = (state: AppState) => {
  state.fulfillmentCenters = []
  state.fulfillmentCentersFilters = undefined
  state.fulfillmentCentersStatus = 'idle'
}

const setAssignedDock = (state: AppState, action: PayloadAction<Dock | undefined>) => ({
  ...state, assignedDock: action.payload,
})

const getUserBadge = justForSideEffect()
const getUserBarcode = justForSideEffect()
const getAvailableFulfillmentCenters = justForSideEffectWithPayload<FulfillmentCenterTypeFilters>()

const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    isLoading,
    setToken,
    setUserBadge,
    getUserBadge,
    setUserBarcode,
    getUserBarcode,
    setFulfillmentCenters,
    setFulfillmentCentersFilters,
    setFulfillmentCentersStatus,
    clearFulfillmentCenters,
    getAvailableFulfillmentCenters,
    setAssignedDock,
  },
})

export default slice.reducer

export const { actions } = slice
